<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['chartdata', 'options','dataname'],
        mounted () {
            Chart.defaults.global.legend.display = false;
            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#527281',
                        data: this.options,
                    },
                    // {
                    //     label: 'test',
                    //     backgroundColor: '#000',
                    //     data: [60,50,45,84,52,62,52,96,100,112],
                    // }
                ]
            }, { responsive: true, maintainAspectRatio: false })
        }
    }
</script>

<style scoped>



</style>
